import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import { LEAD_GENERATOR_THREAD_QUERY_OPTIONS } from "../../../queries/const";
import { aiAgentQueryKeys } from "../../../queries/queryKeyFactory";
import { leadGeneratorThreadService } from "../services/thread";

/**
 * Hook to access the lead gen thread data
 * Will use prefetched/persisted data if available, otherwise will create a new thread
 *
 * Creates different threads for saved searches vs regular searches
 */
export const useLeadGeneratorAgentThread = (savedSearchId?: string | null) => {
    const existingThreadId = useMemo(
        () => leadGeneratorThreadService.getExistingThreadId({ savedSearchId }),
        [savedSearchId],
    );

    return useQuery<string>({
        queryKey: aiAgentQueryKeys.leadGenerator.thread(savedSearchId),
        initialData: existingThreadId ?? undefined,
        ...LEAD_GENERATOR_THREAD_QUERY_OPTIONS,
        queryFn: () => leadGeneratorThreadService.createThread(),
        throwOnError: true,
        // Don't retry on failure to prevent duplicate thread creation
        retry: false,
    });
};
